import { Service } from "app/config/service";
import API_ROUTES from "app/constants/routes/api";
import { getItem, resetSession, setItem } from "app/utils/session";
import { DELETE_USER, GET_PROFILE_DETAILS } from "./types";
import { setProfileDetails } from "./action";
import get from "lodash/get";
import { setNotificationMessage } from "../home/action";
import history from "app/history";
import APP_ROUTES from "app/constants/routes/app";
import { setPopUpMessageData } from "../jobs/action";

const { createLogic } = require("redux-logic");

const getProfileDetailsLogic = createLogic({
    type: GET_PROFILE_DETAILS,
    latest: true,
    process({ action, getState }, dispatch, done) {
        Service({
            method: "post",
            url: API_ROUTES.GET_PROFILE_DETAILS,
            data: { authToken: getItem("token") },
        })
            .then((res) => {
                const userDetails = get(res, "data.data", {});
                dispatch(setProfileDetails(userDetails));
                const user_data = getItem("user_data")
                setItem(
                  "user_data",
                  JSON.stringify({
                    ...(user_data && JSON.parse(user_data)),
                    permittedJobType: userDetails?.permittedJobType,
                  })
                );
                done();
            })
            .catch((err) => {
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }))
                done();
            });
    },
});

const deleteUserLogic = createLogic({
    type: DELETE_USER,
    latest: true,
    process({ action, getState }, dispatch, done) {
        const payload = {
            authToken: getItem("token"),
            userId: action.payload.userId
        }
        Service({
            method: "delete",
            url: API_ROUTES.DELETE_USER,
            data: payload,
        })
            .then((res) => {
                if (res?.data?.data) {
                    history.push(APP_ROUTES.LOGIN);
                    resetSession()
                    dispatch(setNotificationMessage({ type: "success", message: "userDeletedSuccessfully" }))
                }
                done();
            })
            .catch((err) => {
                dispatch(setPopUpMessageData({ modal: true, message: ["errorMsg"] }))
                done();
            });
    },
});

export default [getProfileDetailsLogic, deleteUserLogic];
